export const STORAGE_KEY = 'synctool-token';
export const LOGGED_IN_ROUTE = '/reports';

export const ACCESS_LEVEL = {
  account_manager: 'account_manager', // visible: accounts
  manager: 'manager', // visible: reports, accounts, plugin, staff, credentials, letters, statistics
  operator: 'operator', // visible: reports, accounts, letters, statistics
  scout: 'scout', // visible: reports, accounts
  teamlead: 'teamlead', // visible: reports, accounts, plugin, staff, credentials, letters, statistics
  agency: 'agency', // visible: all
  observer: 'observer', // visible: accounts
  visor: 'visor' // visible: accounts
};

export const SUBDOMAINS = {
  dm: 'ds',
  nc: 'nc',
  pd: 'pd',
  of: 'of'
};

export const GRANTED_HOSTS = {
  dm: 'dm',
  nc: 'root',
  pd: 'pd',
  of: 'of'
};


export const HOST_TO_URL = {
  [GRANTED_HOSTS.dm]: 'http://ds.synctool.team',
  [GRANTED_HOSTS.nc]: 'http://nc.synctool.team',
  [GRANTED_HOSTS.pd]: 'http://pd.synctool.team',
  [GRANTED_HOSTS.of]: 'http://of.synctool.team'
};
